import styled from 'styled-components'

export const StyledRemoveRoute = styled.div`
  section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: ${props => props.theme.spacing.large};

    p {
      font-size: 1.125rem;
    }

    button {
      width: calc(50% - 0.5rem);
    }
  }
`
